<template>
  <a-modal
    :open="visible"
    title="Новая сервисная планировка для црм"
    :confirm-loading="loading"
    ok-text="Сохранить"
    cancel-text="Отменить"
    @ok="handleOk"
    @cancel="handleCancel">
    <a-form layout="vertical">
      <a-form-item
        label="UUID сервисной планировки"
        required>
        <a-input
          v-model:value="planUuid"
          placeholder="Скопируйте UUID сервисной планировки" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script setup>
import { ref, watch } from 'vue';
import { message } from 'ant-design-vue';
import { api } from '@/api';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  crmPlanId: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['close', 'success']);

const planUuid = ref('');
const loading = ref(false);

const handleOk = async () => {
  if (!planUuid.value) {
    message.error('Please enter a Plan UUID');
    return;
  }

  loading.value = true;
  try {
    await api.overridePlan({
      crmPlanId: props.crmPlanId,
      planId: planUuid.value,
    });
    message.success('Plan successfully updated');
    planUuid.value = '';
    emit('success');
    emit('close');
  } catch (e) {
    message.error(e.response?.data?.message || 'Error setting plan');
  } finally {
    loading.value = false;
  }
};

const handleCancel = () => {
  planUuid.value = '';
  emit('close');
};

watch(() => props.visible, (newVal) => {
  if (!newVal) {
    planUuid.value = '';
  }
});
</script>
